var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"title":_vm.name,"placement":"bottom"}},[_c('div',{style:(_vm.statusStyle)},[_c('topology-source-icon',{style:({
        fontSize: '26px',
        color: '#1890ff',
        margin: '2px',
        cursor: 'pointer',
      }),attrs:{"source-type":_vm.sourceType}})],1),_c('div',{staticClass:"service-node-name text-overflow-multiline",staticStyle:{"width":"80px","font-size":"11px","color":"#575757","text-align":"center","margin":"1px 0 0 -18px","cursor":"default","line-height":"1.3em"}},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }